import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';
import { Section } from 'ui/molecules/Section/Section';

import styles from './EditorialStepsSection.module.scss';

import { type EditorialBackground, type EditorialStepsSectionProps } from './EditorialStepsSection.types';

const BACKGROUND_PRESETS: Record<EditorialBackground, string> = {
  blue: 'radial-gradient(ellipse 70% 60% at 15% 0%, rgba(5, 80, 226, 0.14), transparent 60%), radial-gradient(ellipse 60% 50% at 100% 100%, rgba(56, 66, 205, 0.1), transparent 65%), linear-gradient(160deg, #eef4ff 0%, #f7faff 100%)',
  navy: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(51, 92, 244, 0.25), transparent 70%), linear-gradient(160deg, #042354 0%, #081d3d 100%)',
};

export const EditorialStepsSection = ({
  id,
  title,
  description,
  extra,
  actions,
  bottomContent,
  steps,
  background,
  splitAlign = 'top',
  splitSticky = true,
  theme = 'light',
  className,
}: EditorialStepsSectionProps) => (
  <Section
    id={id}
    layout="split"
    splitAlign={splitAlign}
    splitSticky={splitSticky}
    theme={theme}
    title={title}
    description={description}
    extra={extra}
    actions={actions}
    bottomContent={bottomContent}
    background={background && BACKGROUND_PRESETS[background]}
    className={className}
    introBlockClassName={cn(styles.intro, theme === 'dark' && styles.introDark)}
  >
    <div className={cn(styles.steps, theme === 'dark' && styles.dark)}>
      {steps.map((step) => (
        <div key={step.num} className={styles.step}>
          <span className={styles.stepNumber} aria-hidden="true">
            {step.num}
          </span>

          <div className={styles.stepContent}>
            <p className={styles.stepTitle}>{step.title}</p>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>

          {step.iconType && (
            <div className={styles.stepIcon}>
              <Icon type={step.iconType} size="md" />
            </div>
          )}
        </div>
      ))}
    </div>
  </Section>
);
